module.exports = __webpack_public_path__ + "static/media/arrow-solid-hover.26401dd9.svg";